import { render, staticRenderFns } from "./AppPreferences.vue?vue&type=template&id=03413f46&scoped=true"
import script from "./AppPreferences.vue?vue&type=script&lang=js"
export * from "./AppPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03413f46",
  null
  
)

export default component.exports